import React, {useMemo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import Contact from "models/contact"
import ContactPoint from "models/contact-point"
import ContactPointsTable from "components/contact-points/table"
import memo from "set-state-compare/build/memo"
import Nav from "./nav"
import Text from "@kaspernj/api-maker/build/utils/text"
import {useAdminLayout} from "components/admin/layout"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import useModel from "@kaspernj/api-maker/build/use-model"
import {useParams} from "@kaspernj/api-maker/build/router/route"
import {View} from "react-native"

/** @type {Record<string, object>} */
const styles = {}
/** @type {Array<string>} */
const contactPointsPreload = ["notification_type_action", "notification_type_audit_trigger"]
/** @type {Record<string, Array<string>>} */
const contactPointsSelect = {
  ContactPoint: ["createdAt", "description", "expiresAt", "givenAt", "id", "points"],
  NotificationTypeAction: ["id", "name", "translatedActionType"],
  NotificationTypeAuditTrigger: ["auditAction", "auditableType", "id"]
}

/** Admin contact points route. */
export default memo(shapeComponent(class RoutesAdminContactsContactPoints extends ShapeComponent {
  /** @returns {void} */
  setup() {
    const {t} = useI18n({namespace: "js.routes.admin.contacts.contact_points"})
    const params = useParams()
    const {contact, contactId} = useModel(Contact, {
      match: {params},
      select: {
        Contact: ["contactPointsCount", "id", "name"]
      }
    })
    /** @type {import("@kaspernj/api-maker/build/collection.js").default} */
    const contactPointsQuery = useMemo(
      () =>
        ContactPoint
          .ransack({contact_id_eq: contactId})
          .preload(contactPointsPreload)
          .select(contactPointsSelect),
      [contactId]
    )

    this.contact = contact
    this.contactPointsQuery = contactPointsQuery
    this.t = t

    useAdminLayout()?.setState({active: "contacts", headerTitle: t(".contact_points")})
  }

  /** @returns {React.ReactNode} */
  render() {
    const {contact, contactPointsQuery, t} = this

    return (
      <View dataSet={{route: "admin/contacts/contact-points"}} testID="admin-contact-contact-points-route">
        {contact &&
          <Nav
            active="contact-points"
            contact={contact}
            style={styles.nav ||= {marginBottom: 10}}
            testID="admin-contact-contact-points-nav"
          />
        }
        <View style={styles.introductionContainer ||= {marginBottom: 16}} testID="admin-contact-contact-points-introduction">
          <Text
            style={styles.introductionTitle ||= {fontSize: 18, fontWeight: 700, marginBottom: 6}}
            testID="admin-contact-contact-points-introduction-title"
          >
            {t(".understanding_points")}
          </Text>
          <Text
            style={styles.introductionText ||= {color: "#4b5563", lineHeight: 22}}
            testID="admin-contact-contact-points-introduction-text"
          >
            {t(".introduction")}
          </Text>
        </View>
        <ContactPointsTable
          adminLayout
          collection={contactPointsQuery}
        />
      </View>
    )
  }
}))
